import { useState } from "react";
import { useEffect } from "react";

export const MoreInfo = (props) => {
  const [title, setTitle] = useState(null);

  useEffect(() => {
    if (props.data && props.data.title) {
      setTitle("Meer info over " + props.data.title);
    } else {
      setTitle(props.cta);
    }
  }, []);

  return (
    props.data &&
    props.data.hasDetail && (
      <footer className="c-fiche__footer">
        <a
          href={!props.openPopup && props.url}
          target={!props.openPopup && props.target}
          onClick={() => {
            if (props.openPopup) {
              props.openPopup(props.data.urlSegment);
            }
          }}
          className={`minimal c-link--icon`}
          title={title}
        >
          {props.cta}
          <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
        </a>
      </footer>
    )
  );
};
